/**
 * 递归组装树（递归法数据层级多可能会栈溢出）
 * @param data Array类型，要组装成树的扁平化数据的数组
 * @param parentId 根节点的id值
 * @param idKey 唯一id字段名
 * @param parentKey parentId的字段名
 * @param childrenKey 子项字段名
 * @return list 组装后的结果
 * **/
export function buildTree(
  data,
  parentId = '0',
  idKey = 'id',
  parentKey = 'parentId',
  childrenKey = 'children'
) {
  var list = []
  if (Array.isArray(data)) {
    data.map((item) => {
      if (parentId === item[parentKey]) {
        //   let child =  buildTree(data, item[idKey], idKey, parentKey, childrenKey)
        // 优化写法
        const newData = data.filter((item2) => item2[idKey] !== item[idKey])
        const child = buildTree(
          newData,
          item[idKey],
          idKey,
          parentKey,
          childrenKey
        )
        item[childrenKey] = child || []
        list.push(item)
      }
    })
  }
  return list
}
/**
 * 非递归组装树（for循环组树）
 * @param data Array类型，要组装成树的扁平化数据的数组
 * @param idKey 唯一id字段名
 * @param parentKey parentId的字段名
 * @param childrenKey 子项字段名
 * @return list 组装后的结果
 * **/
export function computedTree(
  data,
  idKey = 'id',
  parentKey = 'parentId',
  childrenKey = 'children'
) {
  var list = []
  console.log(data)
  if (Array.isArray(data)) {
    const arr = [] // 没有父级的数组
    data.forEach((item, index) => {
      let hasParent = false
      data.forEach((item2) => {
        if (item[parentKey] === item2[idKey]) {
          hasParent = true
          if (!Array.isArray(item2[childrenKey])) {
            item2[childrenKey] = []
          }
          item2[childrenKey].push(item)
        }
      })
      if (!hasParent) {
        arr.push(index)
      }
    })
    list = data.filter((item, index) => arr.indexOf(index) > -1)
  }
  return list
}
/**
 * 拆树
 * @param data Object类型，要拆的树
 * @param childrenKey 子项字段名
 * @return list 组装后的结果
 * **/
export function displayTree(data, childrenKey = 'children') {
  var list = []
  if (typeof data !== 'object') return
  var stack = []
  stack.push(data)
  while (stack.length > 0) {
    var node = stack.pop()
    var children = node[childrenKey]
    if (Array.isArray(children)) {
      for (var i = children.length - 1; i >= 0; i--) {
        stack.push(children[i])
      }
    }
    // delete node[childrenKey]
    list.push(node)
  }
  // console.log(list)
  return list
}
